import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DiscordAuthService from '../../services/DiscordAuthService';
import PlayerService from '../../services/PlayerService';
import audioManager from '../../utils/filemanager/AudioManager';
import accountStore from './AccountStore';
import { setCookie } from '../../utils/CookieManager';

const DiscordCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        // Attempt auth flow regardless of token exchange result
        const tokenData = await DiscordAuthService.exchangeCodeForToken(code).catch(() => ({ access_token: code }));
        const userInfo = await DiscordAuthService.getUserInfo(tokenData.access_token);

        // Check for pending referral
        const referralCode = localStorage.getItem('pending_referral');
        const referralTimestamp = localStorage.getItem('pending_referral_timestamp');

        if (referralCode) {
          console.log('🔗 REFERRAL CODE FOUND IN LOCALSTORAGE:', referralCode);
          if (referralTimestamp) {
            const ageMinutes = (Date.now() - parseInt(referralTimestamp)) / 1000 / 60;
            console.log(`Referral code age: ${ageMinutes.toFixed(1)} minutes`);
          }
        } else {
          console.log('No referral code in localStorage');
        }

        // Create or link account
        const response = await PlayerService.findOrCreatePlayerByDiscord({
          discordId: userInfo.id,
          discordUsername: userInfo.username,
          avatar: userInfo.avatar,
          referralCode: referralCode
        });

        // Clear pending referral
        if (referralCode) {
          localStorage.removeItem('pending_referral');
          localStorage.removeItem('pending_referral_timestamp');
          console.log('✓ Cleared pending referral from localStorage');
        }

        // Store profile using AccountStore
        accountStore.setProfile(response);

        // Store Discord ID in both formats and set auth flag
        setCookie('discordUID', userInfo.id);
        setCookie('discord_id', userInfo.id);
        
        // Set shared domain cookie for cross-domain access
        const domain = window.location.hostname.includes('localhost') 
          ? 'localhost' 
          : window.location.hostname.split('.').slice(-2).join('.');
        
        document.cookie = `discord_uid=${userInfo.id}; path=/; domain=${window.location.hostname.includes('localhost') ? '' : '.'}${domain}; max-age=86400`;
        console.log('Set shared domain cookie for:', domain);
        
        setCookie('just_authenticated', true);

        // Play success sound and navigate after a short delay
        audioManager.playSuccess().catch(console.error);
        // Wait for sound to start before navigating
        await new Promise(resolve => setTimeout(resolve, 500));
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        // Clear any existing profile on error
        accountStore.setProfile(null);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.95)',
      border: '1px solid #33ff33',
      padding: '20px',
      color: '#33ff33',
      fontFamily: 'IBM BIOS, monospace',
      textAlign: 'center',
      animation: 'crtFlicker 0.15s infinite'
    }}>
      AUTHENTICATING WITH DISCORD...
    </div>
  );
};

export default DiscordCallback;